import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from '../components/Layout';
import { HomePage } from '../features/home';
import { ImportPage } from '../features/imports';
import { EvolutionPage } from '../features/evolution';
import { CategoriesPage } from '../features/categories';
import { BudgetPage } from '../features/budgets';
import { InstallmentPage } from '../features/installments';
import { AnalyticsPage } from '../features/analytics';
import { PaymentsPage } from '../features/payments';
import { useAuth, GoogleLogin, GoogleCallback } from '../features/auth';
import PendingAccessPage from '../features/home/pages/PendingAccessPage';
import { AdminUsersPage } from '../features/admin';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  if (isLoading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" /></div>;
  if (!isAuthenticated) return <GoogleLogin />;
  if (user?.status === 'pending') return <PendingAccessPage />;
  if (user?.status === 'blocked') return <div className="min-h-screen flex items-center justify-center"><p className="text-red-600 font-medium">🚫 Acesso bloqueado. Contate o administrador.</p></div>;
  return <>{children}</>;
};

const AppRoutes: React.FC = () => {
  const hash = window.location.hash;

  if (hash.includes('id_token') || hash.includes('error')) {
    return <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}><GoogleCallback /></BrowserRouter>;
  }

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ProtectedRoute>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/evolution" element={<EvolutionPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/budgets" element={<BudgetPage />} />
            <Route path="/installments" element={<InstallmentPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/imports" element={<ImportPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
          </Routes>
        </Layout>
      </ProtectedRoute>
    </BrowserRouter>
  );
};

export default AppRoutes;
